/**
 * Created by Jie Gao on 2021-02-22.
 */
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GGGameMode} from "../gamemode/GGGameMode";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GGParsedGameData} from "../server/data/GGParsedGameData";

export class GGDoubleBombZeroBetController extends ZeroBetController{

   constructor() {
      super();
   }

   protected calculateIsTriggered(data:ParsedServerData):boolean {
      return data.nextMode === GGGameMode.DOUBLE_BOMB;
   }

   protected getZeroBetNumberLeft(data:GGParsedGameData):number {
      return data.doubleBombSpins;
   }

   public shouldSubtractZeroBetCounter():boolean {
      return true;
   }

   public shouldShowZeroBetCounter():boolean {
      return true;
   }

}